import React, { useEffect, useState, createRef } from "react";
import _ from "lodash";
import { CSVReader } from "react-papaparse";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "components/TextField";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import moment from "moment";
import Pagination from "components/Pagination";
import Select from "components/Select";
import Button from "components/Button";
import {
  imsSendTrackingSheet,
  imsRetailOrders,
  imsRetailShippingPrice,
  imsRetailLogos,
  getTrackingUSNumber,
  imsRetailSendMultipleOrderTracking,
  imsRetailOrder,
  imsRetailOrderEvents,
} from "actions/orders";
import { showLoader, hideLoader } from "actions/loader";
import { months, years } from "pages/smart-print-sink/data";
import OrbitkitModal from "pages/ims-retail/OrbitkitModal";
import { imsPriceList4 } from "pages/ims-retail/ims-price-list";
import {
  Container,
  Title,
  PaginationWrapper,
  OrderWrapper,
  OrderCard,
  Status,
  Header,
  Filter,
  ShippedTag,
  AutocompleteWrapper,
} from "styles/pages/smart-print-sink";

const take = 20;
const salesReportRef = createRef();
const trackingFileRef = createRef();
const buttonRef = createRef();

const SmartSinkPrint = () => {
  const dispatch = useDispatch();
  const [orders, setOrders] = useState(null);
  const [logos, setLogos] = useState(null);
  const [selectedLogoName, setLogoName] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [month, setMonth] = useState("Jan");
  const [year, setYear] = useState(2022);
  const [csvFileData, setCsvFileData] = useState([]);
  const [trackingFileData, setTrackingFileData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpenDialog = (e) => {
    if (buttonRef.current) {
      buttonRef.current.open(e);
    }
  };

  const fetchOrders = async () => {
    const skip = (currentPage === 0 ? currentPage : currentPage - 1) * take;
    const response = await dispatch(
      imsRetailOrders({ skip, take, logoName: selectedLogoName })
    );
    setOrders(response);
  };

  useEffect(() => {
    fetchOrders();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage, selectedLogoName]);

  useEffect(() => {
    (async () => {
      const response = await dispatch(imsRetailLogos());
      setLogos(response);
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleOnFileLoad = async (data) => {
    const rows = [
      [
        "Order Id",
        "Status",
        "Print Provider",
        "Shipping Region",
        "Shipping Country",
        "Order Submit Date",
        "Order Ship Date",
        "Tracking Number",
        "Shipping Cost (USD)",
        "Shipping Method",
        "Line Item SKU",
        "Color",
        "Size",
        "Quantity",
        "Item Weight (lbs)",
        "Print Type",
        "Line Item Cost (USD)",
        // 'Decoration Cost (USD)',
        // 'Total Cost Without Tax (USD)',
        // 'Tax Percentage',
        // 'Tax (USD)',
        "Total Cost (USD)",
      ],
    ];

    //   JSON.stringify(
    //     data?.map((d) => ({
    //       sku: d?.data[1],
    //       price1: Number(d?.data[2]?.split("$")[1]),
    //       price2: 0,
    //     }))
    //   )
    // );
    // return;

    for (let i = 0; i < data?.length; i++) {
      const o = data[i];
      const orderNumber = o?.data[0];

      const imsRetailOrderResponse = await dispatch(
        imsRetailOrder({ orderNumber })
      );
      const events = await dispatch(imsRetailOrderEvents({ id: orderNumber }));

      const orderData = imsRetailOrderResponse?.cart;

      const shippedEvent = events?.find((e) => e?.action === "shipped");
      const createdEvent = events?.find((e) => e?.action === "created");
      const tackingNumber = shippedEvent
        ? `'${shippedEvent?.tracking?.trackingNumber}`
        : "";

      let shippingCost = 0;

      if ((month === "May" || month === "June") && year === 2022) {
        const orderPrice =
          data?.length > 0
            ? await dispatch(
                imsRetailShippingPrice(orderData?.header[0]?.sessionid[0])
              )
            : null;
        shippingCost = orderPrice?.shipmentCost || 11.54;
      }

      for (let j = 0; j < orderData?.item?.length; j++) {
        const row = [
          orderData?.header[0]?.sessionid[0],
          shippedEvent ? "Shipped" : "Processed",
          "US",
          orderData?.header[0]?.shippinginfo[0]?.state[0],
          orderData?.header[0]?.shippinginfo[0]?.country[0],
          createdEvent?.time
            ? moment(createdEvent?.time).format("MMM DD, YYYY")
            : "",
          shippedEvent?.time
            ? moment(shippedEvent?.time).format("MMM DD, YYYY")
            : "",
          tackingNumber,
          j === 0 ? shippingCost : 0,
          (month === "May" || month === "June") && year === 2022
            ? "DHL"
            : "FedEx",
        ];
        const lineItem = orderData?.item[j];

        const qty = Number(lineItem?.qty[0]);

        const spc = lineItem?.spc[0] || "Not Present";
        const sku = lineItem?.suppitemnum[0] || "Not Present";

        const selectedSpc = imsPriceList4?.find((p) => p?.sku === sku) ||
          imsPriceList4?.find((p) => p?.sku === spc) || {
            price1: 0,
            price2: 0,
          };

        // let fulfillmentCost =
        //   Number(qty) < 11 ? selectedSpc?.price1 : selectedSpc?.price2;
        let fulfillmentCost = selectedSpc?.price1;

        const size = lineItem?.customfield1[0]?.value[0]?.split(" ");

        if (size?.length > 1) {
          const extraCharge = Number(
            size[1]?.replace("(", "")?.replace("$", "")?.replace(")", "") || 0
          );

          fulfillmentCost = Number(
            ((fulfillmentCost + extraCharge) * Number(qty)).toFixed(2)
          );
        } else {
          fulfillmentCost = Number((fulfillmentCost * Number(qty)).toFixed(2));
        }

        const costWithoutTax = (shippingCost + fulfillmentCost).toFixed(2); // + embPrice * qty

        // const taxAmount = Number(
        //   ((4 * Number(costWithoutTax)) / 100).toFixed(2)
        // );

        row.push(lineItem?.suppitemnum[0] || "Not Present");
        row.push(lineItem?.color[0]);
        row.push(size[0]);
        row.push(qty);
        row.push(lineItem?.weightperctn[0]);
        row.push("EMB");
        row.push(fulfillmentCost);
        // row.push(embPrice * qty);
        // row.push(costWithoutTax);
        // row.push('4%');
        // row.push(taxAmount);
        row.push(Number(costWithoutTax).toFixed(2));
        rows.push(row);
      }
    }

    setTimeout(() => {
      salesReportRef.current?.link?.click();
    }, 0);
  };

  const handleOnError = (err, file, inputElem, reason) => {
    alert(err);
  };

  return (
    <Container>
      <Header>
        <Title>Ims Retail</Title>

        <Filter>
          <Select
            options={months}
            value={month}
            onChange={(v) => setMonth(v)}
          />

          <Select options={years} value={year} onChange={(v) => setYear(v)} />

          {/* <CSVReader
            ref={buttonRef}
            onFileLoad={handleOnFileLoad}
            onError={handleOnError}
            noClick
            noDrag
            noProgressBar
          >
            {({ file }) => (
              <aside
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <button
                  type="button"
                  onClick={handleOpenDialog}
                  style={{
                    width: 100,
                    cursor: "pointer",
                    background: "#000",
                    color: "#fff",
                    border: "none",
                    fontWeight: "bold",
                    minHeight: 35,
                  }}
                >
                  Upload file
                </button>
                {file && (
                  <div
                    style={{
                      borderWidth: 1,
                      borderStyle: "solid",
                      borderColor: "#000",
                      textAlign: "center",
                      minHeight: 35,
                      lineHeight: 2.5,
                      width: 200,
                      fontSize: 12,
                    }}
                  >
                    {file && file.name}
                  </div>
                )}
              </aside>
            )}
          </CSVReader> */}

          <Button
            title="Sales Report"
            onClick={async () => {
              const date = moment({ year, month: _.indexOf(months, month) });
              const payload = {
                date: `${date?.format("YYYY")}-${date?.format("MM")}`,
                status: "Approved",
              };

              const response = await dispatch(imsRetailOrders(payload));

              const data = [
                [
                  "Order Id",
                  "Status",
                  "Print Provider",
                  "Shipping Region",
                  "Shipping Country",
                  "Order Submit Date",
                  "Order Ship Date",
                  "Tracking Number",
                  "Shipping Cost (USD)",
                  "Shipping Method",
                  "Line Item SKU",
                  "SPC Code",
                  "Color",
                  "Size",
                  "Quantity",
                  "Item Weight (lbs)",
                  "Print Type",
                  "Unit Cost (USD)",
                  "Line Item Cost (USD)",
                  // 'Decoration Cost (USD)',
                  // 'Total Cost Without Tax (USD)',
                  // 'Tax Percentage',
                  // 'Tax (USD)',
                  "Decoration Cost (USD)",
                  "Total Cost Without Tax (USD)",
                  "Tax Percentage",
                  "Tax (USD)",
                  "Total Cost (USD)",
                ],
              ];

              for (let i = 0; i < response?.orders?.length; i++) {
                const o = response?.orders[i];
                const events = o?.events;

                const orderData = o?.cart;

                const shipmentResponse = await dispatch(
                  getTrackingUSNumber({
                    orderId: `${orderData?.header[0]?.sessionid[0]}`,
                  })
                );

                const tackingNumber =
                  shipmentResponse?.shipments
                    ?.map((s) => s?.trackingNumber)
                    ?.join(", ") || "";

                const shippedEvent = events?.find(
                  (e) => e?.action === "shipped"
                );

                const createdEvent = events?.find(
                  (e) => e?.action === "created"
                );

                let shippingCost = 0;

                if ((month === "May" || month === "June") && year === 2022) {
                  const orderPrice =
                    response?.orders?.length > 0
                      ? await dispatch(
                          imsRetailShippingPrice(
                            orderData?.header[0]?.sessionid[0]
                          )
                        )
                      : null;
                  shippingCost = orderPrice?.shipmentCost || 11.54;
                }

                // const embPrice = 25;

                for (let j = 0; j < orderData?.item?.length; j++) {
                  shippingCost = j === 0 ? shippingCost : 0;
                  const row = [
                    orderData?.header[0]?.sessionid[0],
                    "Processed",
                    "US",
                    orderData?.header[0]?.shippinginfo[0]?.state[0],
                    orderData?.header[0]?.shippinginfo[0]?.country[0],
                    createdEvent?.time
                      ? moment(createdEvent?.time).format("MMM DD, YYYY")
                      : "",
                    shippedEvent?.time
                      ? moment(shippedEvent?.time).format("MMM DD, YYYY")
                      : "",
                    tackingNumber,
                    shippingCost,
                    (month === "May" || month === "June") && year === 2022
                      ? "DHL"
                      : "FedEx",
                  ];
                  const lineItem = orderData?.item[j];

                  const qty = Number(lineItem?.qty[0]);

                  // const decorationCost = Number((qty * 8.35).toFixed(2));
                  const decorationCost = 0;

                  const spc =
                    lineItem?.spc[0] || lineItem?.itemnum[0] || "Not Present";

                  const sku =
                    lineItem?.suppitemnum[0] ||
                    lineItem?.itemnum[0] ||
                    "Not Present";

                  const selectedSpc = imsPriceList4?.find(
                    (p) =>
                      p?.sku === lineItem?.suppitemnum[0] ||
                      (lineItem?.itemnum[0] && p?.spc === lineItem?.spc[0])
                  ) || { price1: 0, price2: 0 };

                  // let fulfillmentCost =
                  //   Number(qty) < 11
                  //     ? selectedSpc?.price1
                  //     : selectedSpc?.price2;

                  let fulfillmentCost = selectedSpc?.price1;

                  const size = lineItem?.customfield1[0]?.value[0]?.split(" ");

                  if (size?.length > 1) {
                    const extraCharge = Number(
                      size[1]
                        ?.replace("(", "")
                        ?.replace("$", "")
                        ?.replace(")", "") || 0
                    );

                    fulfillmentCost = Number(
                      ((fulfillmentCost + extraCharge) * Number(qty)).toFixed(2)
                    );
                  } else {
                    fulfillmentCost = Number(
                      (fulfillmentCost * Number(qty)).toFixed(2)
                    );
                  }

                  const costWithoutTax = Number(
                    (shippingCost + fulfillmentCost + decorationCost).toFixed(2)
                  ); // + embPrice * qty

                  const taxPercentage = 0;

                  const costWithTax = Number(
                    ((costWithoutTax * taxPercentage) / 100).toFixed(2)
                  );

                  row.push(sku);
                  row.push(spc);
                  row.push(lineItem?.color[0]);
                  row.push(size[0]);
                  row.push(qty);
                  row.push(lineItem?.weightperctn[0]);
                  row.push("EMB");
                  // row.push(
                  //   Number(qty) < 11 ? selectedSpc?.price1 : selectedSpc?.price2
                  // );
                  row.push(selectedSpc?.price1);
                  row.push(fulfillmentCost);
                  // row.push(embPrice * qty);
                  // row.push(costWithoutTax);
                  // row.push('4%');
                  // row.push(taxAmount);
                  row.push(decorationCost);

                  row.push(costWithoutTax);
                  row.push(`${taxPercentage}%`);
                  row.push(costWithTax);
                  row.push((costWithoutTax + costWithTax).toFixed(2));
                  data.push(row);
                }
              }

              setCsvFileData(data);

              setTimeout(() => {
                salesReportRef.current?.link?.click();
              }, 0);
            }}
          />

          <Button
            title="Check Order Events"
            onClick={async () => {
              for (let i = 0; i < orders?.orders?.length; i++) {
                const order = orders?.orders[i];

                const shipmentResponse = await dispatch(
                  getTrackingUSNumber({
                    orderId: `${order?.cart?.header[0]?.sessionid[0]}`,
                  })
                );

                if (shipmentResponse?.shipments?.length > 0) {
                  const trackNumberArr = shipmentResponse?.shipments?.map(
                    (s) => s?.trackingNumber
                  );

                  if (
                    !order?.InformedTracking ||
                    (!!order?.InformedTracking &&
                      !!trackNumberArr &&
                      order?.InformedTracking?.length !==
                        trackNumberArr?.length)
                  ) {
                    await dispatch(
                      imsRetailSendMultipleOrderTracking({
                        OrderNumber: order?.cart?.header[0]?.sessionid[0],
                        trackNumberArr,
                      })
                    );
                  }
                }
              }
            }}
          />

          <Button
            title="Tracking Sheet"
            onClick={async () => {
              const date = moment({ year, month: _.indexOf(months, month) });
              const payload = {
                date: `${date?.format("YYYY")}-${date?.format("MM")}`,
                status: "Approved",
              };

              const response = await dispatch(imsRetailOrders(payload));

              const shippedOrders = response?.orders?.filter(
                (o) => !!o?.events?.find((f) => f?.action === "shipped")
              );

              const data = [["Order_Id", "Tracking_Number", "Marketplace"]];

              for (let i = 0; i < shippedOrders?.length; i++) {
                const o = shippedOrders[i];

                const row = [];
                row.push(o?.cart?.header[0]?.sessionid[0]);
                row.push(
                  `'${
                    o?.events?.find((d) => d?.action === "shipped")?.tracking
                      ?.trackingNumber
                  }`
                );
                row.push("IMS Retails (FICO)");
                data.push(row);
              }

              if (data?.length > 1) {
                setTrackingFileData(data);
                setTimeout(() => {
                  trackingFileRef.current?.link?.click();
                }, 0);
              }
            }}
          />
        </Filter>
      </Header>

      <AutocompleteWrapper>
        <Autocomplete
          options={logos}
          getOptionLabel={(option) => option}
          onChange={(event, newValue) => {
            setLogoName(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Filter Orders by Logo Name" />
          )}
        />
      </AutocompleteWrapper>

      {!!orders?.orders?.length && (
        <OrderWrapper>
          {orders?.orders?.map((o) => {
            const events = o?.events;

            const isShipped = !!events?.find((r) => r?.action === "shipped");

            return (
              <OrderCard key={o?._id} onClick={() => setSelectedData(o)}>
                {isShipped && <ShippedTag>Shipped</ShippedTag>}
                <Status
                  approved={o?.Status === "Approved"}
                  declined={
                    o?.Status === "Declined" || o?.Status === "Cancelled"
                  }
                  processed={o?.Status === "Processed"}
                  shipped={o?.Status === "Shipped"}
                >
                  {o?.Status}
                </Status>
                <h4>Id : {o?.cart?.header[0]?.sessionid[0]}</h4>
                <div style={{ float: "right" }}>
                  {moment(o?.events[0]?.time).format("MMM DD, YYYY")}
                </div>
              </OrderCard>
            );
          })}
        </OrderWrapper>
      )}

      {orders?.ordersCount > take && (
        <PaginationWrapper>
          <Pagination
            totalCount={orders?.ordersCount}
            take={take}
            page={currentPage}
            onChange={(e, v) => {
              setCurrentPage(v);
            }}
          />
        </PaginationWrapper>
      )}

      <CSVLink
        style={{ display: "none" }}
        ref={salesReportRef}
        filename={`IMS Retail (Sales Report - ${month} ${year}).csv`}
        data={csvFileData}
      >
        Download me
      </CSVLink>

      <CSVLink
        style={{ display: "none" }}
        ref={trackingFileRef}
        filename={`IMS Retails (FICO) (Tracking Sheet - ${month} ${year}).csv`}
        data={trackingFileData}
        onClick={(event) => {
          fetch(event.target.href)
            .then((res) => {
              return res.blob();
            })
            .then(async (blob) => {
              const file = new File(
                [blob],
                `IMS (Tracking Sheet - ${month} ${year}).csv`,
                blob
              );
              dispatch(showLoader());

              const API_ENDPOINT =
                "https://api.cloudinary.com/v1_1/big-oven-tees-inc/upload";
              const fileData = new FormData();
              fileData.append("file", file);
              fileData.append("upload_preset", "tnedst8q");
              fileData.append("folder", `BOTApp/IMS-TrackingSheets/`);
              const data = await fetch(API_ENDPOINT, {
                method: "post",
                body: fileData,
              });

              dispatch(hideLoader());

              const json = await data?.json();
              await dispatch(
                imsSendTrackingSheet({
                  trackingSheet: json?.secure_url,
                  date: `${month} ${year}`,
                })
              );
            });
          return false;
        }}
      >
        Download me
      </CSVLink>

      {selectedData && (
        <OrbitkitModal
          open={!!selectedData}
          data={selectedData}
          onClose={() => {
            setSelectedData(false);
            fetchOrders();
          }}
        />
      )}
    </Container>
  );
};

export default SmartSinkPrint;
